<template>
  <div class="not-found">
    <div class="wrapper">
      <div class="service">
        <div class="service__bg">
          <img src="../../assets/images/404.svg" alt="404 Image">
        </div>
        <div class="service__text">
          <h1 class="margin-bottom--20">Error (404)</h1>
          <p class="margin-bottom--10 font-bold">Entschuldigung, die Seite die Sie versucht haben zu erreichen, konnte nicht gefunden werden.</p>
          <p>Vielleicht haben Sie einen toten Link gedrückt oder eine falsche URL eingegeben. Kann passieren. Starten Sie doch einfach nochmal auf unserer Homepage.
          </p>
          <router-link to="/" class="button margin-top--30">
            Zurück zur Startseite
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../components/Icon/Icon';
import Headline from '../../components/Headline/Headline';

export default {
  name: 'PageNotFound',
  components: {
    Icon,
    Headline,
  },
  data() {
    return {
      msg: 'Behördengänge einfach Online erledigen',
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
  methods: {
    ...mapMutations({
        login: 'auth/login',
        logout: 'auth/logout',
      }),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./PageNotFound.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/PageNotFound/PageNotFound.vue